import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { PortalSidebar } from './PortalSidebar';
import { PortalHeader } from './PortalHeader';
import { usePortalAuth } from '@/hooks/portal/usePortalAuth';
import { Loader2 } from 'lucide-react';
import PortalErrorBoundary from './PortalErrorBoundary';

export function PortalLayout() {
  const { user, isLoading } = usePortalAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !user) {
      navigate('/portal/login');
    }
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return null; // Will redirect in useEffect
  }

  return (
    <SidebarProvider>
      <PortalSidebar />
      <SidebarInset>
        <PortalHeader />
        <main className="flex-1 overflow-auto p-4 md:p-6">
          <PortalErrorBoundary>
            <Outlet />
          </PortalErrorBoundary>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
